<template>
	<div>
		<CustomTable
			ref="monte_resa"
			id_table="monte_resa_suivi"
			primaryKey="id"
			:items="items"
			:busy.sync="table_busy"
			:hrefsRoutes="config_table_hrefs"
			:base-filters="tableFilters"
			:externSlotColumns="['trackings_link', 'destinataire.tiers_rs', 'last_notification_date']"
		>
			<template v-slot:custom-slot-cell(trackings_link)="{ data }">
				<a href="" class="" @click.prevent="openTrackings(data.id)">{{ $t('global.see_trackings') }}</a>
			</template>
			<template v-slot:custom-slot-cell(destinataire.tiers_rs)="{ data }">
				<router-link :to="{ name: 'tiersFiche', params: { tiers_id: data.destinataire.tiers_id } }">{{ data.destinataire.tiers_rs }}</router-link>
				<template v-if="data.destinataire.tiers_alias && data.destinataire.tiers_alias !== data.destinataire.tiers_rs"><br /><i>{{ data.destinataire.tiers_alias }}</i></template>
			</template>
			<template v-slot:custom-slot-cell(last_notification_date)="{ data }">
				<div v-for="notif in data.notification_list" :key="notif.id" style="white-space: nowrap">
					<a href="" @click.prevent="openNotificationPreview(data, notif.id)">{{ formatNotifDate(notif.date) }}</a>
				</div>
			</template>
		</CustomTable>

		<b-modal size="xl" ref="modalTracking" hide-footer>
			<template v-slot:modal-title>
				{{ $t("global.tracking") }}
			</template>
			<Trackings :resa_id='resa_tracking_id' />
		</b-modal>
	</div>
</template>
 

<script type="text/javascript">
    import Navigation from "@/mixins/Navigation.js"
	import MonteReservationOrder from "@/mixins/MonteReservationOrder.js"

	export default {
		name: "Track",
		props: {
			items: { type: Array, default: () => [] },
			table_busy: { type: Boolean, default: false }
		},
		mixins: [Navigation, MonteReservationOrder],
		data () {
			return {
				resa_tracking_id: null,
				events_tab: {
					"MonteReservation::RefreshTrack": () => { this.$refs.monte_resa.refreshTable() },
				},
				config_table_hrefs: {
					'expediteur.tiers_rs': {
						routeUniqueName: 'tierExpeFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'expediteur.tiers_id'
						}
					},
					'destinataire.tiers_rs': {
						routeUniqueName: 'tierDestFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'destinataire.tiers_id'
						}
					},
					'stallion.horse_nom': {
						routeUniqueName: 'stallionFiche',
						routeName: 'horseFiche',
						params: {
							horse_id: 'stallion.horse_id'
						}
					},
					'mare.horse_nom': {
						routeUniqueName: 'mareFiche',
						routeName: 'horseFiche',
						params: {
							horse_id: 'stallion.horse_id'
						}
					},
					'contract.contract_num': {
						routeUniqueName: 'contractFiche',
						routeName: 'ContractFormv2',
						params: {
							contract_id: 'contract.contract_id'
						}
					},
				}
			}
		},
		methods: {
			unselectAll() {
				this.$refs.monte_resa.unselectAll()
			},

			openTrackings(resa_id) {
				this.resa_tracking_id = resa_id
				this.$refs.modalTracking.show()
			}
		},
		computed: {
			tableFilters() {
				return {
					order_status: {
						column: 'status_code',
						operator: 'isEqualTo',
						value: 4
					}
				}
			}
		},
		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable'),
			Trackings : () => import('@/components/Trackings')
		}
	}
</script>
